import { render, staticRenderFns } from "./Opt.vue?vue&type=template&id=ac4f7de2&scoped=true&"
import script from "./Opt.vue?vue&type=script&lang=ts&"
export * from "./Opt.vue?vue&type=script&lang=ts&"
import style0 from "./Opt.vue?vue&type=style&index=0&id=ac4f7de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4f7de2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VRow,VSheet,VSwitch})
